import React from "react";
import { RoomStatus } from "@/types/room";

const getStatus = (status: RoomStatus) => {
  const statusConfig = {
    [RoomStatus.OCCUPIED]: {
      className: "text-destructive",
      label: "Occupied",
    },
    [RoomStatus.AVAILABLE]: { className: "text-accent-green", label: "Free" },
    [RoomStatus.BOOKED]: {
      className: "text-accent-orange",
      label: "Booked",
    },
    [RoomStatus.OUT_OF_SERVICE]: {
      className: "text-destructive",
      label: "Unavailable",
    },
  };

  const config = statusConfig[status];

  return <span className={config.className}>{config.label}</span>;
};

export const RoomStatusLabel = ({ status }: { status: RoomStatus }) =>
  getStatus(status);
